var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJobCommon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.274 7.63574C19.856 7.63574 16.274 11.4417 16.274 16.1357C16.274 20.8297 19.856 24.6357 24.274 24.6357C28.692 24.6357 32.274 20.8297 32.274 16.1357C32.274 11.4417 28.69 7.63574 24.274 7.63574Z",
    fill: "#C6C6D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 25.5308H28.163C27.947 25.5308 27.736 25.6008 27.563 25.7308L25.45 27.3148C24.739 27.8478 23.761 27.8478 23.05 27.3148L20.939 25.7308C20.766 25.6008 20.555 25.5308 20.339 25.5308H17.752C14.395 25.5308 11.39 27.6138 10.212 30.7578L8.85301 34.3838C7.53701 37.8928 10.131 41.6358 13.879 41.6358H34.621C38.369 41.6358 40.963 37.8928 39.648 34.3838L38.288 30.7548C37.11 27.6118 34.105 25.5308 30.75 25.5308Z",
    fill: "#5452CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobCommon);
export default __webpack_public_path__ + "static/media/job-common.b2583b64e564e9546b76d32c8548304e.svg";
export { ForwardRef as ReactComponent };